import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { CreateClassifierFields } from '@dealstack/frontend/app/pages/Project/DealSettings/Classifiers/types';

export const createClassifierValidation = z.object({
	[CreateClassifierFields.name]: z.string(),
	[CreateClassifierFields.classifierParentId]: z.string().optional(),
});

export const createClassifierResolver = zodResolver(createClassifierValidation);
